import { liteClient, type LiteClient } from 'algoliasearch/lite'

export type SearchClient = LiteClient

/**
 * Builds the search-only Algolia client shared across every seller surface.
 *
 * Consumers pass their own credentials because the config source differs per
 * build unit (`window.env.*` in `front/seller`, `getConfig()` in `micro/product`),
 * which keeps this package framework- and config-source-neutral.
 */
export function createSearchClient(appId: string, apiKey: string): SearchClient {
  return liteClient(appId, apiKey)
}
